export default {
  currentAssessment: {},
  isFetchingCurrentAssessment: false,
  currentAssessmentError: null,
  assessments: [],
  isFetchingAllAssessments: false,
  assessmentsError: null,
};
